// Copyright (c) 2016 Deere & Company

import Interval, {getDefaultState as getIntervalDefaultState} from './interval';
import t from 'tcomb';

const MaintenancePlan = t.struct({
    id: t.String,
    intervals: t.list(Interval),
    name: t.String,
    uom: t.String
}, {
    name: 'MaintenancePlan',
    strict: true
});

export const getDefaultState = () => new MaintenancePlan({
    id: '',
    intervals: [getIntervalDefaultState()],
    name: '',
    uom: ''
});

export default MaintenancePlan;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/maintenance-plan.js